"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProgressAt = exports.getPosition = exports.getIndex = void 0;
var getIndex = exports.getIndex = function getIndex(step) {
  return step > 1 ? step - 1 : 0;
};
var getPosition = exports.getPosition = function getPosition(index, currentStepIndex) {
  if (index === currentStepIndex) {
    return 'current';
  }
  if (index < currentStepIndex) {
    return 'previous';
  }
  return 'next';
};
var getProgressAt = exports.getProgressAt = function getProgressAt(index, count) {
  return Math.floor(100 * (index + 1) / count);
};